// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Contact Us`
};

const el_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Βρείτε μας`
};

const ru_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `Контакты`
};

const he_contact_us = /** @type {(inputs: {}) => string} */ () => {
	return `צרו קשר`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const contact_us = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.contact_us(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("contact_us", locale)
	if (locale === "en") return en_contact_us(inputs)
	if (locale === "el") return el_contact_us(inputs)
	if (locale === "ru") return ru_contact_us(inputs)
	if (locale === "he") return he_contact_us(inputs)
	return "contact_us"
};